import { useQuery } from '@tanstack/react-query'
import { fetchAttentionQueue, fetchHomeAggregates } from './api.js'

/**
 * 5-minute `staleTime`, matching the aggregate cache tier the backend's
 * `CadenceClient` uses for these same two endpoints (tech stack §2) — no
 * point polling the frontend's copy faster than the number behind it can
 * actually change.
 */
export function useHomeAggregates() {
  return useQuery({
    queryKey: ['home-aggregates'],
    queryFn: fetchHomeAggregates,
    staleTime: 5 * 60_000,
  })
}

export function useAttentionQueue(limit = 6) {
  return useQuery({
    queryKey: ['attention-queue', limit],
    queryFn: () => fetchAttentionQueue(limit),
    staleTime: 5 * 60_000,
  })
}
